import t from "./highrise1302.mjs";
function e() {
  this.__data__ = new t(), this.size = 0;
}
export {
  e as default
};
